import type { ColumnHelper } from '@tanstack/react-table';

export const createdByAccessor = <T extends { created_by?: string }>(
  columnHelper: ColumnHelper<T>,
  createdByUsers?: string[],
) =>
  columnHelper.accessor((row) => row.created_by, {
    id: 'created_by',
    header: 'Created by',
    filterFn: 'arrIncludesSome',
    meta: {
      filter: {
        placeholder: 'All created by',
        options: createdByUsers,
      },
      tooltip: true,
    },
  });
